import { useTheme } from '../context/ThemeContext';

/**
 * A themed checkbox that correctly uses the current theme's --c-action-fg colour
 * for the checkmark SVG.
 *
 * CSS custom properties can't be referenced inside SVG data URLs, so the normal
 * .t-checkbox:checked { background-image: url(...) } rule must use a hardcoded
 * colour. This component reads --c-action-fg from getComputedStyle at render time
 * and injects it as an inline backgroundImage, which always beats the CSS class.
 *
 * It re-renders whenever the active theme or custom theme changes, so the
 * checkmark colour stays in sync with any built-in or user-created theme.
 */
export default function ThemedCheckbox({ checked, className = '', style: styleProp = {}, ...props }) {
  // Subscribing to these values ensures a re-render on every theme switch.
  // eslint-disable-next-line no-unused-vars
  const { theme, activeCustomThemeId } = useTheme();

  let checkmarkStyle = {};
  if (checked) {
    const actionFg = getComputedStyle(document.documentElement)
      .getPropertyValue('--c-action-fg').trim() || '#ffffff';
    const encoded = actionFg.replace('#', '%23');
    const svg = `url("data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M3.5 8l3.5 3.5 5.5-6' stroke='${encoded}' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c%2fsvg%3e")`;
    checkmarkStyle = { backgroundImage: svg };
  }

  return (
    <input
      type="checkbox"
      checked={checked}
      className={className}
      style={{ ...styleProp, ...checkmarkStyle }}
      {...props}
    />
  );
}
